export let Product = /*#__PURE__*/function (Product) {
  Product["OLO"] = "olo";
  return Product;
}({});
export let PageName = /*#__PURE__*/function (PageName) {
  PageName["KANBAN"] = "orders_page_kanban_view";
  PageName["KANBAN_PENDING"] = "orders_page_kanban_view_pending";
  PageName["KANBAN_ACCEPTED"] = "orders_page_kanban_view_accepted";
  PageName["KANBAN_READY"] = "orders_page_kanban_view_ready";
  PageName["KANBAN_OUT_FOR_DELIVERY"] = "orders_page_kanban_view_out_for_delivery";
  PageName["CALENDAR"] = "orders_page_calendar_view";
  PageName["ONLINE_ORDERING"] = "online-ordering";
  PageName["ECOM_ORDERS"] = "ecom_orders";
  PageName["WEB_POS"] = "web-pos";
  PageName["ORDER_WITH_GOOGLE"] = "order_with_google";
  PageName["OLO_SETTINGS"] = "olo_settings";
  PageName["RESTAURANTS_SIDEBAR_FOOTER"] = "restaurants_sidebar_footer";
  PageName["WEB_NOTIFICATIONS_SETTINGS"] = "web_notifications_settings";
  PageName["MIGRATION_SHUTDOWN_OLO_PAGE"] = "migration-shutdown-olo-page";
  PageName["MIGRATION_SHUTDOWN_MENUS_PAGE"] = "migration-shutdown-menus-page";
  PageName["ORDER_UPDATES_AND_NOTIFICATIONS"] = "order-updates-and-notifications";
  return PageName;
}({});
export let Hosting = /*#__PURE__*/function (Hosting) {
  Hosting["BM"] = "dashboard|WIX";
  Hosting["MOBILE"] = "mobile|WIX";
  Hosting["EDITOR"] = "editor|WIX";
  Hosting["EDITOR_X"] = "editorX|WIX";
  Hosting["ADI"] = "adi|WIX";
  Hosting["PREVIEW"] = "preview|WIX";
  Hosting["VIEWER"] = "viewer|WIX";
  Hosting["STUDIO"] = "studio|WIX";
  return Hosting;
}({});
export let OrderingStatus = /*#__PURE__*/function (OrderingStatus) {
  OrderingStatus["NOT_READY"] = "not_ready_to_accept_orders";
  OrderingStatus["NOT_ACCEPTING_ORDERS"] = "not_accepting_orders_now";
  OrderingStatus["ACCEPTING_ORDERS"] = "accepting_orders_now";
  return OrderingStatus;
}({});
export let WidgetName = /*#__PURE__*/function (WidgetName) {
  WidgetName["MENU"] = "Menu";
  WidgetName["SECTION"] = "Section";
  WidgetName["DISHES"] = "Dishes";
  WidgetName["DISPATCH_MODAL"] = "DispatchModal";
  WidgetName["ITEM_MODAL"] = "itemModal";
  WidgetName["HEADER"] = "Header";
  WidgetName["NAVIGATION"] = "Navigation";
  WidgetName["OLO"] = "OLO";
  return WidgetName;
}({});
export let LivesiteFulfillmentType = /*#__PURE__*/function (LivesiteFulfillmentType) {
  LivesiteFulfillmentType["PICKUP"] = "pickup";
  LivesiteFulfillmentType["DELIVERY"] = "delivery";
  return LivesiteFulfillmentType;
}({});
export let MenusObjectType = /*#__PURE__*/function (MenusObjectType) {
  MenusObjectType["MENU"] = "menu";
  MenusObjectType["SECTION"] = "section";
  MenusObjectType["ITEM"] = "item";
  return MenusObjectType;
}({});
export let MenusPageName = /*#__PURE__*/function (MenusPageName) {
  MenusPageName["MENUS"] = "menus";
  MenusPageName["ITEMS"] = "items";
  MenusPageName["MENU"] = "menu";
  return MenusPageName;
}({});
export let ModalName = /*#__PURE__*/function (ModalName) {
  ModalName["FULFILLMENT_MODAL"] = "manual-order-fulfillment-modal";
  ModalName["CONNECT_OWG_AGREEMENT_MODAL"] = "connect_order_with_google_agreement_modal";
  ModalName["DISCONNECT_LOCATION_MODAL"] = "disconnect_location_modal";
  ModalName["WEB_NOTIFICATIONS_SETTINGS"] = "web_notifications_settings";
  return ModalName;
}({});
export let DeliverPartnerModal = /*#__PURE__*/function (DeliverPartnerModal) {
  DeliverPartnerModal["ACCEPT_ORDER"] = "accept_order";
  DeliverPartnerModal["REJECT_ORDER"] = "reject_order";
  DeliverPartnerModal["CANCEL_ORDER"] = "cancel_order";
  DeliverPartnerModal["REQUIRES_ADDITIONAL_CHARGE"] = "requires_additional_charge";
  return DeliverPartnerModal;
}({});
//# sourceMappingURL=constants.js.map